import type { FC } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { Headline } from '@xing-com/typography';

import Icon from './assets/upsell_icon_green.png';
import * as Styled from './upsell-banner.styles';
import { getMarketingPageUrl } from './utils';

type UpsellBannerVerticalProps = {
  headerCopyKey: string;
  bodyCopyKey: string;
  moduleName: string;
};
export const UpsellBannerVertical: FC<UpsellBannerVerticalProps> = ({
  headerCopyKey,
  bodyCopyKey,
  moduleName,
}) => {
  const intl = useIntl();
  const { pageContext } = usePageContext();

  const marketingPageUrl = getMarketingPageUrl({
    locale: intl.locale,
    moduleName,
    focusType: pageContext.focusType,
  });

  return (
    <Styled.PremiumWrapperVertical>
      <Styled.ContentWrapper>
        <Styled.TextWrapper>
          <Styled.Flag>
            <FormattedMessage id="EP_FLAG_EMPLOYER_BRANDING_PROFILE" />
          </Styled.Flag>
          <Styled.HeaderText>
            <Headline size="xlarge">
              <FormattedMessage id={headerCopyKey} />
            </Headline>
          </Styled.HeaderText>
          <Styled.Text>
            <FormattedMessage id={bodyCopyKey} />
          </Styled.Text>
        </Styled.TextWrapper>
        <Styled.PremiumButtonMargin>
          <Styled.PremiumButton
            size="medium"
            variant="proBusiness"
            href={marketingPageUrl}
            // @ts-expect-error TS(2769) FIXME: No overload matches this call.
            target="_blank"
            rel="noopener nofollow"
          >
            <FormattedMessage id="EP_UPSELL_GALLERY_BUTTON" />
          </Styled.PremiumButton>
        </Styled.PremiumButtonMargin>
      </Styled.ContentWrapper>
      <Styled.IconVertical src={Icon} alt="Upsell icon green" />
    </Styled.PremiumWrapperVertical>
  );
};
